import { Box, Text, Heading } from 'theme-ui'
import Image from 'next/image'

function Empty() {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                flex: 1,
                maxHeight: '70vh',
            }}
        >
            <Image
                src="/pages/yearbook/empty-placeholder.png"
                width={90}
                height={89}
            />
            <Heading as="h1" sx={{ pt: 3 }}>
                No matches
            </Heading>
            <Text sx={{ fontSize: 3, fontWeight: 'body', pt: 2 }}>
                Unfortunately we couldn’t find a match for your search.
            </Text>
        </Box>
    )
}

export default Empty
